exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.permission{border-collapse:collapse}table.permission th{font-size:14px;border:1px solid #ccc;line-height:35px}table.permission td{border:1px solid #ccc;font-size:12px!important}.fontBold{font-weight:bolder}.tableTd{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dd8a905","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Userrole/setRolePermission.vue
// module id = 1042
// module chunks = 3